
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.805 5.53c.26.26.26.682 0 .942L2.276 8.001l1.529 1.528a.667.667 0 01-.943.943l-2-2a.667.667 0 010-.943l2-2c.26-.26.682-.26.943 0zM7.529.861c.26-.26.682-.26.942 0l2 2a.667.667 0 01-.942.943L8 2.275l-1.529 1.53a.667.667 0 11-.942-.944l2-2zM5.529 12.195c.26-.26.682-.26.942 0L8 13.724l1.529-1.529a.667.667 0 11.942.943l-2 2a.667.667 0 01-.942 0l-2-2a.667.667 0 010-.943zM12.195 5.53c.26-.261.683-.261.943 0l2 2c.26.26.26.682 0 .942l-2 2a.667.667 0 01-.943-.943l1.529-1.528-1.529-1.529a.667.667 0 010-.943z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.667 8c0-.368.298-.666.666-.666h13.334a.667.667 0 010 1.333H1.333a.667.667 0 01-.666-.666z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 .666c.368 0 .667.298.667.667v13.333a.667.667 0 11-1.334 0V1.333c0-.369.299-.667.667-.667z"}})])
          )
        }
      }
    